import {useQuery} from '@tanstack/react-query'

import type {CategoryDetailQueryProps} from '@/lib/food-grubhub/foodCategoryGrubhubModel'
import {getCategoryDetailInfo} from '@/lib/food-grubhub/foodGrubhubService'

const useGrubhubGetCategoryDetail = (params: CategoryDetailQueryProps, token: string) => {
  return useQuery({
    queryKey: ['category_detail', params, token],
    queryFn: async () =>
      getCategoryDetailInfo({
        restaurantId: params.restaurantId ?? '',
        categoryId: params.categoryId ?? '',
        time: params.time ?? 0,
        hideUnavailableMenuItems: params.hideUnavailableMenuItems ?? true,
        orderType: params.orderType ?? 'standard',
        locationMode: params.locationMode ?? '',
        version: params.version ?? 4,
        includeWeightedItemsData: params.includeWeightedItemsData ?? true,
        location: params.location ?? '',
        token,
        signal: undefined,
      }),
    enabled: !!token,
  })
}

export default useGrubhubGetCategoryDetail
